import { redirect } from '@tanstack/react-router'

export function redirectHome() {
  return redirect({
    from: '/$country/$language/navigator/$',
    to: '/$country/$language/navigator',
  })
}

export function redirectToScene(rangeId: string, id: string) {
  return redirect({
    from: '/$country/$language/navigator/$',
    params: { id, rangeId },
    to: '/$country/$language/navigator/$rangeId/$id',
  })
}
